module.exports = __webpack_public_path__ + "static/sjzl-83527a4026e6075a51552f1531676b0b.png";